import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'

const MediaUploadInputEditMode = ({
  file,
  handleFieldChange,
  accept,
  name,
  buttonLabel,
  maxFileNameWidth,
}) => {
  const { t } = useTranslation(['create-event'])
  const inputRef = useRef()
  const fileName = !file
    ? t('create-event:mediaUploadInputEditMode.noFile')
    : typeof file === 'string'
      ? file
      : file.name
  const handleChange = (event) => {
    const newFile = event.target.files[0]
    handleFieldChange({ target: { name, value: newFile } })
  }
  const handleClick = (event) => {
    event.preventDefault()
    inputRef.current && inputRef.current.click()
  }
  return (
    <React.Fragment>
      <div className="file-name" style={{ maxWidth: maxFileNameWidth }}>
        {fileName}
      </div>
      <input accept={accept} ref={inputRef} type="file" hidden onChange={handleChange} />
      <button className="button button-primary media-upload-button" onClick={handleClick}>
        {buttonLabel}{' '}
        <Icon
          icon="replace"
          styles={{ width: '18px', height: '18px', marginLeft: '5px' }}
          svgProps={{ fill: 'none', stroke: 'white' }}
        />
      </button>
    </React.Fragment>
  )
}

MediaUploadInputEditMode.propTypes = {
  file: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
  handleFieldChange: PropTypes.func,
  accept: PropTypes.string,
  name: PropTypes.string,
  buttonLabel: PropTypes.string,
  maxFileNameWidth: PropTypes.string,
}

export default MediaUploadInputEditMode
